import { ConstManager } from '@goodt-wcore/managers';
import { ControlMixin } from './ControlMixin';
import { ObjectControlMixin } from './ObjectControlMixin';
import { LabelMixin } from './LabelMixin';

const getConstants = () => Object.keys(ConstManager.instance.getConstantsHash());
const getConstantsHash = () => ConstManager.instance.getConstantsHash();

const isConstant = (value) => value != null && typeof value === 'string' && value.match(/^%([^%]+)%$/) !== null;

const createFont = ({
    color = '',
    fontSize = '',
    fontFamily = '',
    fontWeight = '',
    ...rest
} = {}) => ({
    color,
    fontSize,
    fontFamily,
    fontWeight,
    ...rest
});

const createBorder = ({
    color = 'rgba(238, 238, 238, 1)',
    width = '1px',
    style = 'none',
    ...rest
} = {}) => ({
    color,
    width,
    style,
    ...rest
});

const createBorderRadius = ({
    topLeft = '',
    topRight = '',
    bottomRight = '',
    bottomLeft = '',
    ...rest
} = {}) => ({
    topLeft,
    topRight,
    bottomRight,
    bottomLeft,
    ...rest
});

const createShadow = ({
    color = '',
    blur = '',
    shiftX = '',
    shiftY = '',
    type = '',
    ...rest
} = {}) => ({
    color,
    blur,
    shiftX,
    shiftY,
    type,
    ...rest
});

const createDimensionsColorSettings = ({
    color = '',
    step = 0,
    colors = {},
    dimensions = []
} = {}) => ({
    color,
    step,
    colors,
    dimensions
});

const createIndexesColorSettings = ({ colors = [] } = {}) => ({ colors });

const createMetricsColorSettings = ({ metric = '' } = {}) => ({ metric });

const createCustomizableColor = ({
    type = '',
    dimensions = createDimensionsColorSettings(),
    metrics = createMetricsColorSettings(),
    indexes = createIndexesColorSettings(),
    ...rest
} = {}) => ({
    type,
    dimensions: createDimensionsColorSettings(dimensions),
    metrics: createMetricsColorSettings(metrics),
    indexes: createIndexesColorSettings(indexes),
    ...rest
});

const createPaginationButtonStateSettings = ({ background = '', font = createFont() } = {}) => ({
    font: createFont(font),
    background
});

const createPaginationSettings = ({
    active = createPaginationButtonStateSettings(),
    base = createPaginationButtonStateSettings(),
    height = '',
    width = '',
    position = '',
    gap = '',
    pages = 0,
    borderRadius = createBorderRadius(),
    ...rest
} = {}) => ({
    active: createPaginationButtonStateSettings(active),
    base: createPaginationButtonStateSettings(base),
    height,
    width,
    position,
    gap,
    pages,
    borderRadius: createBorderRadius(borderRadius),
    ...rest
});

const isValidColor = (value) => CSS.supports('background', value);

export {
    ControlMixin,
    LabelMixin,
    ObjectControlMixin,
    getConstants,
    getConstantsHash,
    isConstant,
    createFont,
    createBorder,
    createShadow,
    createCustomizableColor,
    createBorderRadius,
    createPaginationSettings,
    isValidColor
};
